import { ref } from 'vue';

const activeActionPicker = ref(null);

export function setActiveActionPicker(actionPicker) {
  activeActionPicker.value = actionPicker;
}

export function getActiveActionPicker() {
  return activeActionPicker.value;
}

export function closeActiveActionPicker() {
  if (activeActionPicker.value) {
    activeActionPicker.value(false); // Close the currently open ActionPicker
    activeActionPicker.value = null;
  }
}